export var AssetStatus;
(function (AssetStatus) {
    /**
     * Assets to play this recording in the browser exist
     */
    AssetStatus["Exists"] = "exists";
    /**
     * Assets to play this recording in the browser are broken or not able to be generated
     */
    AssetStatus["Broken"] = "broken";
    /**
     * Assets to play this recording in the browser are being generated
     */
    AssetStatus["Generating"] = "generating";
    /**
     * Assets to play this recording in the browser are missing, possibly archived, possibly awaiting generation
     */
    AssetStatus["Missing"] = "missing";
})(AssetStatus || (AssetStatus = {}));
